import React, { useRef, useEffect } from 'react';
import classNames from 'classnames/bind';

import SelectCustomType from './SelectCustomType';
import SelectGroupType from './SelectGroupType';
import SelectLocation from './SelectLocation';
import SelectDuration from './SelectDuration';
import SelectPassenger from './SelectPassenger';
import SelectBudget from './SelectBudget';

import styles from './index.module.scss';
import usePopupHandler from '@/hooks/custom/usePopupHandler';

const cx = classNames.bind(styles);

export enum CustomTravelEstimatePopupStep {
  SelectCustomType = 'custom-type',
  SelectGroupType = 'group-type',
  SelectLocation = 'location',
  SelectDuration = 'duration',
  SelectPassenger = 'passenger',
  SelectBudget = 'budget',
}

export enum CustomTravelEstimateStepArea {
  'custom-type' = 'type',
  'group-type' = 'advgrouptype',
  'location' = 'selfdestination',
  'duration' = 'selfschedule',
  'passenger' = 'selfpersonal',
  'budget' = 'selfbudget',
}

export enum CustomTravelParamType {
  ADVISOR_TYPE = 'advisor',
  CHECK_ESTIMATE = 'check',
}

interface CustomTravelEstimatePopupProps {
  step: CustomTravelEstimatePopupStep;
}

const CustomTravelEstimatePopup: React.FC<CustomTravelEstimatePopupProps> = ({ step }) => {
  const popupContentRef = useRef<HTMLDivElement>(null);
  const { handleClose } = usePopupHandler();

  useEffect(() => {
    const handleDocumentClick = (e: MouseEvent) => {
      if (!popupContentRef.current?.contains(e.target as Node)) {
        handleClose();
      }
    };

    document.body.style.overflow = 'hidden';
    document.addEventListener('click', handleDocumentClick, true);

    return () => {
      document.body.style.removeProperty('overflow');
      document.removeEventListener('click', handleDocumentClick, true);
    };
  }, [handleClose]);

  return (
    <div className={cx('CustomTravelEstimatePopup')} ref={popupContentRef}>
      <div className={cx('head')}>
        <button
          type="button"
          className={cx('close')}
          aria-label="닫기"
          onClick={handleClose}
          data-event-nlog="click"
          data-event-area-code={`cus.${CustomTravelEstimateStepArea[step]}closepage`}
        />
      </div>
      {step === CustomTravelEstimatePopupStep.SelectCustomType && <SelectCustomType />}
      {step === CustomTravelEstimatePopupStep.SelectGroupType && <SelectGroupType />}
      {step === CustomTravelEstimatePopupStep.SelectLocation && <SelectLocation />}
      {step === CustomTravelEstimatePopupStep.SelectDuration && <SelectDuration />}
      {step === CustomTravelEstimatePopupStep.SelectPassenger && <SelectPassenger />}
      {step === CustomTravelEstimatePopupStep.SelectBudget && <SelectBudget />}
    </div>
  );
};

export default CustomTravelEstimatePopup;
